// # #############################################
// # Title : Map Zip / Brand selector
// # Authors : Atul, Shubham
// # Date : 15th October 2019
// # Last Modified : Shubham, October 2019
// # Version : 19.10.03
// # Description : This is the code for rendering the mapbox render level(zip/msa) and brand selector
// # ############################################

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';


const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
  noLabel: {
    marginTop: theme.spacing.unit * 3,
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};


function getStyles(name, that) {
  return {
    fontWeight:
      that.state.name.indexOf(name) === -1
        ? that.props.theme.typography.fontWeightRegular
        : that.props.theme.typography.fontWeightMedium,
  };
}

class MultipleSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = { name: props.defaultValue };
  }

  handleChange = event => {
    this.props.action(event);
    this.setState({ name: event.target.value });
  };



  render() {
    const { classes } = this.props;
    const { items } = this.props;
    let disabled = false;

    //for OpenScenario disabling Aggregation Mode and setting default to cumulative
    if (this.props.label === 'Aggregation Mode' && sessionStorage.getItem("namespace") === "openScenario") {
      disabled = true;
    }

    return (

      <FormControl className={classes.formControl} disabled={disabled}>
        <InputLabel htmlFor="select-multiple" className="OptionLabel">{this.props.label}</InputLabel>
        <Select
          value={this.state.name}
          onChange={this.handleChange}
          input={<Input id="select-multiple" />}
          MenuProps={MenuProps}
        >
          {items.map(name => (
            <MenuItem key={name.value} value={name.value} style={getStyles(name, this)}>
              {name.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

    );
  }
}


export default withStyles(styles, { withTheme: true })(MultipleSelect);